<template>
  <div>
    <div class="container">
      <!-- 引入 Loading 组件 -->
      <!-- 左侧导航栏 -->
      <!-- <div class="sidebar">
      <ul class="nav">
        <li class="nav-item active">基础服务</li>
        <li class="nav-item">数据碰撞</li>
      </ul>
    </div> -->

      <!-- 主体内容 -->

      <div class="main-content">
        <!-- 顶部筛选栏 -->
        <div class="filter-container">
          <div class="filter-group">
            <el-tooltip
              content="可选择您企业所在领域，若需用到其他领域数据，也可选择多个领域"
              placement="top"
              effect="dark"
              :open-delay="500"
            >
              <div class="newsoan">选择领域</div>
            </el-tooltip>

            <div class="filter-items">
              <el-checkbox-group
                size="normal"
                class="newgrpoup"
                v-model="checkedApplicationAreas"
                @change="handleCheckedApplicationAreas"
              >
                <el-checkbox-button
                  v-for="area in applicationAreas"
                  :label="area.name"
                  :key="area.id"
                  class="custom-checkbox-button"
                >
                  {{ area.name }}
                </el-checkbox-button>
              </el-checkbox-group>
            </div>
          </div>
        </div>

        <!-- 数据选择区域 -->
        <div class="filter-containers">
          <el-tooltip
            content="可选择所选领域下的任意数据，作为生成数据产品开发方向的数据基础"
            placement="top"
            effect="dark"
            :open-delay="500"
          >
            <div class="newsoan">
              选择数据
            </div>
          </el-tooltip>

          <div class="needs">
            <div class="tuuiuy">
              <el-cascader
                :options="options"
                v-model="selectedValue"
                collapse-tags
                :props="{ multiple: true }"
                placeholder="请选择"
                @change="cascaderHandleChange"
              ></el-cascader>
            </div>
          </div>
          <div class="newsoanss">
            已选择数据
          </div>
          <div class="needsss">
            <div class="newtags">
              <el-tag
                v-for="(item, index) in selectedLabels"
                :key="index"
                @close="removeDatas(item)"
                closable
                style="margin-right: 5px;"
              >
                {{ item }}
              </el-tag>
            </div>

            <div class="centers"></div>
            <el-tooltip
              content="若有数据未能从选择数据下拉框选择，可依次输入数据名称，添加一个或多个数据"
              placement="top"
              effect="dark"
              :open-delay="500"
            >
              <div class="newsoans">自定义数据</div>
            </el-tooltip>
            <div class="filters">
              <el-input
                placeholder="输入后点击按钮添加"
                v-model="inputValue"
                size="samll"
                @input="handleInput"
                style="width: 159px; margin-right: 10px;"
              ></el-input>
              <el-tooltip
                content="点击添加数据"
                placement="top"
                effect="dark"
                :open-delay="500"
              >
                <el-button
                  type="primary"
                  size="samll"
                  icon="el-icon-plus"
                  @click="addData"
                ></el-button>
              </el-tooltip>
              <div class="newtag">
                <el-tag
                  v-for="(data, index) in dataLists"
                  :key="index"
                  closable
                  style="margin-right: 5px;"
                  @close="removeData(index)"
                >
                  {{ data }}
                </el-tag>
              </div>
            </div>
          </div>
        </div>
        <div class="data-status">
          <img src="@/assets/img/checkcircleee.png" class="newimghh" alt="" />
          <span v-if="checkedApplicationAreas.length == 0" class="imghit"
            >暂未选择数据</span
          >
          <span v-else>已选择数据</span>

          <button
            class="generate-btn"
            :disabled="isLoading"
            @click="generateProductSuggestion"
          >
            <span v-if="isLoading">正在思考中...</span>
            <span v-if="isLoading" class="loader"> </span>
            <span v-else>生成数据产品建议</span>
          </button>
        </div>

        <!-- 产品建议区域 -->
        <div class="product-suggestion">
          <div class="suggestion-header">
            <!-- <div class="sort-by">
            <select v-model="sortOrder" @change="handleSortOrderChange">
              <option value="asc">排序方式: 升序</option>
              <option value="desc">排序方式: 降序</option>
            </select>
          </div> -->
            <div class="suggestion-count">
              共生成{{ totalPages }}条产品开发建议
            </div>
          </div>
          <div class="card-container" v-if="items.length > 0">
            <el-row :gutter="20">
              <el-col :span="8" v-for="(item, index) in items" :key="index">
                <el-card shadow="hover" class="custom-card">
                  <div class="card-content">
                    <div class="card-contents">
                      <img src="@/assets/img/model.png" class="newimg" alt="" />
                      <el-tooltip
                        :content="item.productName"
                        placement="top"
                        effect="dark"
                        :open-delay="500"
                      >
                        <span class="card-title" :title="item.productName">
                          {{
                            item.productName.length > 16
                              ? item.productName.slice(0, 16) + "..."
                              : item.productName
                          }}
                        </span>
                      </el-tooltip>
                      <div class="card-actions">
                        <el-button
                          size="mini"
                          type="text"
                          @click="openDialoghuam(index, item)"
                          >开发方向</el-button
                        >
                        <el-button
                          size="mini"
                          type="text"
                          @click="openDialoghuaQ(index, item)"
                          >买方画像</el-button
                        >

                        <el-button
                          size="mini"
                          type="text"
                          @click="openDialogrong(index, item)"
                          >融资建议</el-button
                        >
                      </div>
                    </div>

                    <div class="instate">
                      <div><span>产品类型：</span>{{ item.productType }}</div>
                      <div>
                        <span>产品介绍：</span>{{ item.productDescription }}
                      </div>
                      <div>
                        <span>匹配成功数据：</span>{{ item.useData.join(", ") }}
                      </div>
                      <div>
                        <span>需补充数据：</span
                        >{{ item.missingData.join(", ") }}
                      </div>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 分页 -->
        <div class="pagination" v-if="items.length > 0">
          <el-pagination
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :total="totalPages"
            layout="prev, pager, next, jumper"
            @current-change="handlePageChange"
          >
          </el-pagination>
        </div>

        <!-- 右侧二维码 -->
        <div class="qr-code">
          <img src="https://example.com/qr-code.png" alt="二维码" />
          <p>扫码添加企业微信咨询</p>
        </div>
        <el-dialog
          :visible.sync="dialogVisiblezhuce"
          width="40%"
          :close-on-click-modal="false"
          class="dialog-style"
        >
          <template #title>
            <img
              src="@/assets/bijianli.png"
              alt="图标"
              style="width: 24px; height: 24px; margin-right: 8px;"
            />
            注册提醒
          </template>

          <div class="dialog-content">
            <div class="dialog-body">
              <p>您好，注册成为免费会员，可享受查看3个数据产品建议</p>
              <p>(每个建议包含买方画像、开发建议、融资建议)</p>
            </div>
          </div>

          <div class="dialog-footer">
            <el-button type="primary" @click="handleRegister">去注册</el-button>
          </div>
        </el-dialog>

        <el-dialog
          :visible.sync="dialogVisiblehuiyuan"
          width="40%"
          :close-on-click-modal="false"
          class="dialog-style"
        >
          <template #title>
            <img
              src="@/assets/Vector.png"
              alt="图标"
              style="width: 24px; height: 24px; margin-right: 8px;"
            />
            会员提醒
          </template>

          <div class="dialog-content">
            <div class="dialog-body">
              <p>您好，您的会员权益已用完，可点击下方按钮前往会员中心，</p>
              <p>购买付费会员，继续使用该功能</p>
            </div>
          </div>

          <div class="dialog-footer">
            <el-button type="primary" @click="handleRegisters"
              >去充值</el-button
            >
          </div>
        </el-dialog>
        <el-dialog
          title="交通运输应用领域产品买方画像"
          :visible.sync="dialogVisible"
          width="80%"
        >
          <div id="main" style="width: 100%; display: flex; flex-wrap: wrap;">
            <div style="width: 30%; height: 50vh;">
              <div ref="chart1" style="width: 100%; height: 100%;"></div>
            </div>
            <div style="width: 30%; height: 50vh;">
              <div ref="chart2" style="width: 100%; height: 100%;"></div>
            </div>
            <div style="width: 30%; height: 50vh;">
              <div ref="chart3" style="width: 100%; height: 100%;"></div>
            </div>
          </div>
        </el-dialog>
        <el-dialog
          title="交通运输应用领域产品买方画像"
          :visible.sync="dialogVisible"
          width="80%"
        >
          <div id="main" style="width: 100%; display: flex; flex-wrap: wrap;">
            <div style="width: 30%; height: 50vh;">
              <div ref="chart1" style="width: 100%; height: 100%;"></div>
            </div>
            <div style="width: 30%; height: 50vh;">
              <div ref="chart2" style="width: 100%; height: 100%;"></div>
            </div>
            <div style="width: 30%; height: 50vh;">
              <div ref="chart3" style="width: 100%; height: 100%;"></div>
            </div>
          </div>
        </el-dialog>
        <el-dialog :title="buyer" :visible.sync="dialogVisiblehua" width="65%">
          <div class="details-content">
            <!-- <div class="data-item">
      <p>{{ dataList }}</p>
     {{}}
    </div> -->
            <Loading :isLoading="markdownData.contentBuyer == ''" />
            <MarkdownViewer
            :sanitize="buyer"
              :source="markdownData.contentBuyer"
            ></MarkdownViewer>
            <!-- <div
                        class="preview-content"
                        v-html="compiledMarkdown"
                ></div> -->
            <!-- <div v-html="compiledMarkdown" class="black-text"></div>   -->
            <!-- <span class="gray-text">产品名称：</span> -->
            <!-- <span class="black-text">{{ selectedItems.msg }}</span> -->
          </div>
        </el-dialog>

        <el-dialog
          :title="suggestions"
          :visible.sync="dialogVisiblesu"
          width="65%"
        >
          <div class="details-content">
            <Loading :isLoading="markdownData.suggestion == ''" />

            <MarkdownViewer :source="markdownData.suggestion" :sanitize="suggestions"></MarkdownViewer>
          </div>
        </el-dialog>
        <el-dialog :title="buyers" :visible.sync="dialogVisibles" width="65%">
          <div class="details-content">
            <Loading :isLoading="markdownData.contentF == ''" />

            <MarkdownViewer :source="markdownData.contentF" :sanitize="buyers"></MarkdownViewer>
            <!-- <div
                        class="preview-content"
                        v-html="compiledMarkdown"
                ></div> -->
            <!-- <div v-html="compiledMarkdown" class="black-text"></div>   -->
            <!-- <span class="gray-text">产品名称：</span> -->
            <!-- <span class="black-text">{{ selectedItems.msg }}</span> -->
          </div>
        </el-dialog>

        <el-dialog title="选择省份" :visible.sync="dialogVisiblequ" width="30%">
          <el-form>
            <el-form-item label="省份名称" :label-width="formLabelWidth">
              <el-select v-model="districtName" placeholder="请选择省份">
                <el-option
                  v-for="item in districtOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisiblequ = false">取 消</el-button>
            <el-button type="primary" @click="handleConfirmqu">确 定</el-button>
          </div>
        </el-dialog>
      </div>

      <el-dialog title="选择省市" :visible.sync="dialogVisibleyu" width="30%">
        <el-form>
          <el-form-item label="省市名称" :label-width="formLabelWidth">
            <el-cascader
              v-model="selectedOptions"
              :options="optionsm"
              :props="{ expandTrigger: 'hover' }"
              placeholder="请选择省市"
            >
            </el-cascader>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleyu = false">取 消</el-button>
          <el-button type="primary" @click="confirmSelection">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <component :is="currentComponent[currentIndex]"></component>
  </div>
</template>

<script>
import * as echarts from "echarts";
// import { marked } from 'marked';
import CoreItemOne from "../core_competence/CoreItemOne.vue";
// import hljs from 'highlight.js';
import MarkdownViewer from "../markedownit/index.vue";
// import 'highlight.js/styles/github.css';
import Loading from "../loding/index.vue";
import WebSocketService from "../../utils/webSocketService.js";
import html2pdf from "html2pdf.js";
export default {
  components: {
    Loading,
    // marked,
    MarkdownViewer,
  },
  data() {
    return {
      isLoadings: false,
      buyer: "",
      buyers: "",
      needbigdata: "",
      dialogVisiblezhuce: false,
      dialogVisiblehuiyuan: false,
      suggestions: "",
      timeoutId: null, // 存储定时器 id
      selectedLabels: [],
      options: [], // 存储转换后的选项
      optionsm: [], // 存储转换后的选项
      selectedValue: [], // 存储选中的值
      showDetailsFlags: false, // 控制详情显示
      inputValue: "",
      loading: false,
      isLoading: false,
      dataLists: [],
      currentIndex: 0,
      currentComponent: [CoreItemOne],
      markhuaData: ``,
      markdownData: {},
      dialogVisiblequ: false,
      wsService: null,
      districtName: "",
      districtNamenew: "",
      districtNamenews: "",
      formLabelWidth: "80px",
      dialogVisibleyu: false,
      selectedOptions: [],
      districtOptions: [
        { value: "district1", label: "区县一" },
        { value: "district2", label: "区县二" },
        { value: "district3", label: "区县三" },
        // 这里你可以填你真实的数据
      ],
      dataList: "", // 用于存储接收到的实时数据
      selectedItems: {
        msg: "",
        productIntroduction:
          "本数据集通过收集、整合各类交通数据，为城市交通规划、管理和优化提供有力支持的数据集合。可以实现各种交通数据的实时共享和交换，为交通管理部门提供更加科学、精准的交通规划和管理依据。",
        applicationFields: "交通运输 交通管理",
        buyer: "某某市交通运输公司",
        buyerIndustry: "交通运输业",
        financingMethod: "投资",
        financingAmount: "100万元",
        valuationAmount: "200万元",
        title: "客运数据分析系统",
        domain: "公共交通",
        type: "数据应用",
        description:
          "通过收集、整合各类交通数据，为城市交通规划、管理和优化提供有力支持的数据支撑。",
      }, // 当前选中的详细信息
      // 左侧导航栏
      activeNavItem: "基础服务",
      dialogVisible: false,
      dialogVisibles: false,
      dialogVisiblehua: false,
      dialogVisiblesu: false,
      // 数据选择
      selectedData: null,
      file: null,

      dataGroup: [
        "基础设施数据",
        "公交站点数据",
        "公交线路数据",
        "公交车辆数据",
        "路段数据",
        "建成环境数据",
        "城市客运数据",
        "车辆运营数据",
        "社会域数据",
      ],
      selectedItem: true,
      groupApplicationAreas: [],
      groupAllApplication: false,
      groupIndeterminateApplication: false,
      coverData: [],
      checkedApplicationAreas: [],
      checkAllApplication: false,
      isIndeterminateApplication: false,
      applicationAreas: [],
      // 产品建议

      needdata: null,
      timeoutdata: null,
      suggestionCount: 1,
      sortOrder: "asc",
      currentPage: 1,
      totalPages: 0,
      pageSize: 6,
      activeNames: [], // 当前展开的项的索引数组
      items: [],
    };
  },
  // computed: {
  //       compiledMarkdown() {
  //           return marked(this.markdownData, {
  //               highlight: function(code, language) {
  //                   const validLanguage = hljs.getLanguage(language) ? language : 'plaintext'
  //                   return hljs.highlight(validLanguage, code).value
  //               },
  //               breaks: true
  //           })
  //       }
  //   },

  beforeDestroy() {
    const userId = localStorage.getItem("userId");
    // this.wsService.disconnect(userId); // 组件销毁时关闭 WebSocket 连接
  },
  // watch: {
  //   'markdownData.contentF'(newVal) {
  //     // 当 contentF 为空时，设置 isLoading 为 true
  //     if (newVal === '') {
  //       this.isLoadings = true;
  //       this.startLoadingTimeout();
  //     } else {
  //       // 一旦有内容，就将 isLoading 设为 false
  //       this.isLoadings = false;
  //     }
  //   },
  // },
  methods: {
    exportToPDF(doone) {
      // 确保内容已经加载
      if (doone == "") {
        return;
      } else {
        // 配置参数
        const options = {
          margin: 1,
          filename: `${doone}_文档.pdf`,
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: {
            scale: 2,
            useCORS: true,
            logging: true,
          },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        };

        // 获取要导出的DOM元素
        const element = this.$refs.pdfContent;

        // 生成PDF
        html2pdf()
          .set(options)
          .from(element)
          .save()
          .catch((err) => {
            console.error("导出失败:", err);
          });
      }
    },

    confirmSelection() {
      if (this.selectedOptions.length === 0) {
        this.$message.warning("请选择省市");
        return;
      }
      var city = {};
      const [provinceId, cityId] = this.selectedOptions;
      const province = this.optionsm.find((opt) => opt.value === provinceId);

      if (!province.children) {
        city = province;
      } else {
        city = province.children.find((opt) => opt.value === cityId);
      }

      this.districtNamenew = city.label;
      // this.$message.success(`您选择的省份是：${province.label}\n您选择的城市是：${city.label}`);
      this.dialogVisiblequ = false;
      this.openDialoghuas(this.needdata, this.timeoutdata);
    },
    handleConfirmqu() {
      // 确定按钮的操作，比如提交districtName
      // this.$message.success(`选择了：${this.districtNamenew}`);
      this.dialogVisibleyu = false;
      this.openDialoghua(this.needdata, this.timeoutdata);
    },
    checkMarkdownData(property) {
      // 检查 markdownData 是否为空对象

      if (Object.keys(this.markdownData).length === 0) {
        // 清除已存在的定时器以防多次调用
        this.clearTimeout();

        // 启动 20 秒定时器
        this.timeoutId = setTimeout(() => {
          if (this.markdownData[property] === "") {
            // 设置为“异常”或其他操作
            this.isLoadings = false;
            this.dialogVisiblehua = false;
            this.dialogVisibles = false;
            this.dialogVisiblesu = false;
            this.$message.error("解析失败,请稍后重试！");
          }
          // 清除定时器 id
          this.timeoutId = null;
        }, 20000); // 20秒
      } else {
        // markdownData 不为空时，清除定时器
        this.clearTimeout();
      }
    },
    clearTimeout() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null; // 重置定时器 id
      }
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.generateProductSuggestion();

      console.log("当前页:", page);
    },

    // 递归查找标签
    getLabels(values) {
      let labels = [];
      // 首先扁平化传入的数组
      const flatValues = values.flat();

      const findLabels = (options, selectedValues) => {
        options.forEach((option) => {
          if (selectedValues.includes(option.value)) {
            // 将选中的标签添加到 labels 数组
            labels.push(option.label);
          }
          if (option.children) {
            // 如果有子选项，递归找到标签
            findLabels(option.children, selectedValues);
          }
        });
      };

      // 使用扁平化后的值查找标签
      findLabels(this.options, flatValues);

      // 删除数组中的第一个元素

      return labels; // 返回找到的所有标签
    },
    cascaderHandleChange(value) {
      // this.selectedLabels = this.getLabels(value);

      const result = value.map((subArray) => subArray[1]);
      this.coverData = result;
      this.selectedLabels = this.getLabels(result);
    },
    handleChange(item, value) {
      // 确保只有一个子项是展开的
      if (value.length > 0) {
        item.activeNames = [value[1]];
      } else {
        item.activeNames = [];
      }
    },
    addData() {
      
      if (this.inputValue) {
        this.dataLists.push(this.inputValue);
        this.inputValue = "";
      }
    },
    removeData(index) {
      this.dataLists.splice(index, 1);
    },
    removeDatas(label) {
      const index = this.selectedLabels.indexOf(label);
      if (index !== -1) {
        // 从 selectedLabels 中删除标签
        this.selectedLabels.splice(index, 1);

        // 从 selectedValue 中删除对应的值
        // 这里需要找到对应的 value (假设 selectedValue 存储的是二维数组)
        this.selectedValue = this.selectedValue.filter((items) =>
          items.every((value) => label !== this.getLabels([value]).join(""))
        );
      }
    },

    openDialog() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.initCharts();
      });
    },
    async openDialogrong(jj, QQ) {
      this.timeoutId = null;
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      // const response = await this.axios.get(
      //   `https://www.hittik.com/znsystem/weixin/getUserfunusenum?userId=${userId}`,
      //   config
      // );
      this.$api
        .getUserfunusenum({
          userId: userId,
        })
        .then((responses) => {
          // if (responses) {
          //console.log(response.data);
          //               if (this.qiyetitle != "免费会员") {
          //                 this.members = responses;
          //               }
          //             }
          //           });
          // if (response.data.code == 200) {

          // 将响应数据保存到响应式数据属性中

          if (responses == 0) {
            this.updata();

            this.buyers = QQ.productName + "融资建议";
            const mappedData = {
              product_name: QQ.productName,
              product_description: QQ.productDescription,
              use_data: QQ.useData.join(", "),
              product_type: QQ.productType,
              supplier_name: QQ.supplierName,
              userId: window.neddtime,
              productId: QQ.productId,
              dataSource: QQ.dataSource,
            };
            this.isLoadings = false;
            this.dialogVisibles = true;
            this.markdownData = QQ;

            if (QQ.contentF) {
              return;
            }
            // this.dialogVisibles = true;
            // return

            this.isLoadings = true;
            this.checkMarkdownData("contentF");
            const config = {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            };

            this.$api.getFinancing(mappedData).then((response) => {
              if (response) {
              } else {
                this.$message({
                  message: response.data.msg,
                  type: "error", // 可选类型：success、warning、info、error
                });
                this.isLoadings = false;
              }
            });
            // const url = "https://www.hittik.com/zntop/top/getFinancing";
            // this.axios.post(url, mappedData, config).then((response) => {
            //   if (response.data.code === 200) {

            //     // this.markdownData = response.data.msg ;
            //   } else {
            //     this.$message({
            //       message: response.data.msg,
            //       type: "error", // 可选类型：success、warning、info、error
            //     });
            //     this.isLoadings = false;
            //   }
            // });
          } else {
            this.dialogVisiblehuiyuan = true;
          }

          // this.$nextTick(() => {
          // this.initCharts();
        });
    },
    async updata() {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const prams = {
        userId: userId,
      };

      this.$api.upDateUserfunusenum(prams).then((response) => {
        if (response) {
        } else {
        }
      });
      // const response = await this.axios.post(
      //   `https://www.hittik.com/znsystem/weixin/upDateUserfunusenum?userId=${userId}`,
      //   prams,
      //   config
      // );

      // if (response.data.code == 200) {
      // } else {
      //   this.$message({
      //     message: response.data.msg,
      //     type: "error", // 可选类型：success、warning、info、error
      //   });
      // }
    },
    async openDialoghuaQ(jj, QQ) {
      this.dialogVisiblequ = true;
      this.needdata = jj;
      this.timeoutdata = QQ;

      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      // const response = await this.axios.get(
      //   `https://www.hittik.com/zntop/top/getAreaProvince`,
      //   config
      // );
      this.$api.getAreaProvince().then((responses) => {
        if (responses) {
          this.districtOptions = responses[0].children.map((province) => ({
            value: province.districtName,
            label: province.districtName,
          }));
        }
      });
    },
    formatData(data) {
      return data.map((province) => {
        return {
          value: province.districtId, // 省级 ID
          label: province.districtName, // 省级名称
          children: province.children.map((city) => {
            if (city.children.length > 0) {
              // 只在有子节点时添加
              return {
                value: city.districtId, // 市级 ID
                label: city.districtName, // 市级名称
                children: city.children, // 直接传递有子节点的城市
              };
            } else {
              return {
                value: city.districtId, // 市级 ID
                label: city.districtName, // 市级名称
                children: [], // 没有子节点，children 为空
              };
            }
          }),
        };
      });
    },
    async openDialoghua(jj, QQ) {
      this.timeoutId = null;
      const userId = localStorage.getItem("userId");
      // const token = localStorage.getItem("token");
      // const config = {
      //   headers: {
      //     Authorization: `Bearer ${token}`,
      //   },
      // };

      // const response = await this.axios.get(
      //   `https://www.hittik.com/znsystem/weixin/getUserfunusenum?userId=${userId}`,
      //   config
      // );

      // if (response.data.code == 200) {

      // 将响应数据保存到响应式数据属性中
      this.$api
        .getUserfunusenum({
          userId: userId,
        })
        .then((responses) => {
          if (responses == 0) {
            this.updata();

            this.buyer = QQ.productName + " 买方画像";
            const mappedData = {
              product_name: QQ.productName,
              product_description: QQ.productDescription,
              use_data: QQ.useData.join(", "),
              product_type: QQ.productType,
              supplier_name: QQ.supplierName,
              districtName: this.districtName,
              userId: window.neddtime,
              productId: QQ.productId,
              dataSource: QQ.dataSource,
            };
            this.isLoadings = false;
            this.dialogVisiblehua = true;

            this.markdownData = QQ;
            QQ.contentBuyer = "";
            if (
              QQ.contentBuyer &&
              QQ.contentBuyer.districtName == this.districtName
            ) {
              return;
            }

            // this.dataList=QQ.content
            // this.dataList=QQ.content
            // this.dialogVisibles = true;
            // return

            this.isLoadings = true;
            this.checkMarkdownData("contenBuyer");
            // const url = "https://www.hittik.com/zntop/top/getPersona";
            // const config = {
            //   headers: {
            //     Authorization: `Bearer ${token}`,
            //   },
            // };
            // this.axios.post(url, mappedData, config).then((response) => {
            this.$api.getPersona(mappedData).then((response) => {
              if (response) {
                // this.markhuaData = response.data.msg ;
              } else {
                this.$message({
                  message: response.data.msg,
                  type: "error", // 可选类型：success、warning、info、error
                });
                this.isLoadings = false;
              }
            });
            // this.isLoadings=false

            // this.$nextTick(() => {
            // this.initCharts();
            // });
          } else {
            this.dialogVisiblehuiyuan = true;

            // this.$message({
            //   message: "试用次数已用完，请联系管理员！",
            //   type: "warning", // 可选类型：success、warning、info、error
            // });
          }
        });
    },
    async openDialoghuam(jj, QQ) {
      this.dialogVisibleyu = true;
      this.needdata = jj;
      this.timeoutdata = QQ;

      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      this.$api.getAreaCity().then((responses) => {
        if (responses) {
          //console.log(response.data);
          this.optionsm = this.transformDatas(responses[0].children);
        }
      });
    },
    async openDialoghuas(jj, QQ) {
      this.timeoutId = null;
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      // const response = await this.axios.get(
      //   `https://www.hittik.com/znsystem/weixin/getUserfunusenum?userId=${userId}`,
      //   config
      // );

      this.$api
        .getUserfunusenum({
          userId: userId,
        })
        .then((responses) => {
          // 将响应数据保存到响应式数据属性中

          if (responses == 0) {
            this.updata();

            this.suggestions = QQ.productName + " 开发方向";
            const mappedData = {
              product_name: QQ.productName,
              product_description: QQ.productDescription,
              use_data: QQ.useData.join(", "),
              product_type: QQ.productType,
              supplier_name: QQ.supplierName,
              districtName: this.districtNamenew,
              userId: window.neddtime,
              productId: QQ.productId,
              missingData: QQ.missingData.join(", "),
              dataSource: QQ.dataSource,
              existingData: QQ.useData.join(", "),
            };
            this.isLoadings = false;
            this.dialogVisiblesu = true;

            this.markdownData = QQ;
            QQ.suggestion = "";
            if (
              QQ.suggestion &&
              QQ.suggestion.districtName == this.districtNamenew
            ) {
              return;
            }

            // this.dataList=QQ.content
            // this.dataList=QQ.content

            // return

            this.isLoadings = true;
            this.checkMarkdownData("suggestion");
            // const url = "https://www.hittik.com/zntop/top/getDevelopShow";
            // const config = {
            //   headers: {
            //     Authorization: `Bearer ${token}`,
            //   },
            // };

            this.$api.getDevelopShow(mappedData).then((response) => {
              if (response) {
              } else {
                this.isLoadings = false;
              }
            });
            // this.axios.post(url, mappedData, config).then((response) => {
            //   if (response.data.code === 200) {

            //     // this.markhuaData = response.data.msg ;
            //   } else {
            //     this.$message({
            //       message: response.data.msg,
            //       type: "error", // 可选类型：success、warning、info、error
            //     });
            //     this.isLoadings = false;
            //   }
            // });
            // this.isLoadings=false

            // this.$nextTick(() => {
            // this.initCharts();
            // });
          } else {
            this.dialogVisiblehuiyuan = true;
            // this.$message({
            //   message: "试用次数已用完，请联系管理员！",
            //   type: "warning", // 可选类型：success、warning、info、error
            // });
          }
        });
    },
    initCharts() {
      // 饼图
      const chart1 = echarts.init(this.$refs.chart1);
      const option1 = {
        tooltip: {
          trigger: "item",
        },
        title: {
          text: "买方行业地区占比",
          left: "center", // 将标题居中显示
          top: "bottom", // 将标题放置在底部
          textStyle: {
            fontSize: 20, // 标题文本大小
            fontWeight: "bold", // 字体加粗
            align: "center", // 文本居中
          },
        },
        // legend: {
        //   top: '5%',
        //   left: 'center'
        // },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: true, // 显示标签
              position: "outside", // 标签显示在扇区外部
              formatter: "{d}%", // 格式化标签文本，显示百分比
              rich: {
                // 自定义标签样式
                corner: {
                  color: "#000", // 标签文本颜色
                  fontSize: 12, // 标签字体大小
                  align: "right", // 标签文本右对齐
                  verticalAlign: "middle", // 标签垂直居中
                },
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 1048, name: "Search Engine" },
              { value: 735, name: "Direct" },
              { value: 580, name: "Email" },
              { value: 484, name: "Union Ads" },
              { value: 300, name: "Video Ads" },
            ],
            color: ["#3D57E3", "#5C73EE", "#7F90EE", "#A5B1F2", "#B7C1F1"], // 固定颜色数组
          },
        ],
      };

      //   title: {
      //     text: "买方行业分布占比",
      //     left: "center",
      //   },
      //   tooltip: {
      //     trigger: "item",
      //   },
      //   legend: {
      //     orient: "vertical",
      //     left: "left",
      //   },
      //   series: [
      //     {
      //       name: "类型",
      //       type: "pie",
      //       radius: "50%",
      //       data: [
      //         { value: 51, name: "类型1" },
      //         { value: 429, name: "类型2" },
      //         { value: 528, name: "类型3" },
      //         { value: 472, name: "类型4" },
      //         { value: 408, name: "类型5" },
      //       ],
      //       emphasis: {
      //         itemStyle: {
      //           shadowBlur: 10,
      //           shadowOffsetX: 0,
      //           shadowColor: "rgba(0, 0, 0, 0.5)",
      //         },
      //       },
      //     },
      //   ],
      // };
      chart1.setOption(option1);
      const chart2 = echarts.init(this.$refs.chart2);
      const option2 = {
        tooltip: {
          trigger: "item",
        },
        title: {
          text: "买方地区占比",
          left: "center", // 将标题居中显示
          top: "bottom", // 将标题放置在底部
          textStyle: {
            fontSize: 20, // 标题文本大小
            fontWeight: "bold", // 字体加粗
            align: "center", // 文本居中
          },
        },
        // legend: {
        //   top: '5%',
        //   left: 'center'
        // },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: true, // 显示标签
              position: "outside", // 标签显示在扇区外部
              formatter: "{d}%", // 格式化标签文本，显示百分比
              rich: {
                // 自定义标签样式
                corner: {
                  color: "#000", // 标签文本颜色
                  fontSize: 12, // 标签字体大小
                  align: "right", // 标签文本右对齐
                  verticalAlign: "middle", // 标签垂直居中
                },
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 1048, name: "Search Engine" },
              { value: 735, name: "Direct" },
              { value: 580, name: "Email" },
              { value: 484, name: "Union Ads" },
              { value: 300, name: "Video Ads" },
            ],
            color: ["#0056D2 ", "#007BFF ", "#74B9FF", "#A0C4FF", "#B2E1FF"], // 固定颜色数组
          },
        ],
      };
      chart2.setOption(option2);
      const chart3 = echarts.init(this.$refs.chart3);
      const option3 = {
        tooltip: {
          trigger: "item",
        },
        title: {
          text: "买方不同区间价格占比",
          left: "center", // 将标题居中显示
          top: "bottom", // 将标题放置在底部
          textStyle: {
            fontSize: 20, // 标题文本大小
            fontWeight: "bold", // 字体加粗
            align: "center", // 文本居中
          },
        },
        // legend: {
        //   top: '5%',
        //   left: 'center'
        // },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: true, // 显示标签
              position: "outside", // 标签显示在扇区外部
              formatter: "{d}%", // 格式化标签文本，显示百分比
              rich: {
                // 自定义标签样式
                corner: {
                  color: "#000", // 标签文本颜色
                  fontSize: 12, // 标签字体大小
                  align: "right", // 标签文本右对齐
                  verticalAlign: "middle", // 标签垂直居中
                },
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 1048, name: "Search Engine" },
              { value: 735, name: "Direct" },
              { value: 580, name: "Email" },
              { value: 484, name: "Union Ads" },
              { value: 300, name: "Video Ads" },
            ],
            color: ["#2A8563", "#369B7C", "#58B79B", "#7CC9A6", "#A8EED8"], // 固定颜色数组
          },
        ],
      };
      chart3.setOption(option3);
    },
    handleRegister() {
      this.generateProductSuggestion();
      this.dialogVisiblezhuce = false;
    },
    handleRegisters() {
      //  this.$router.push("/fivenav/1").catch((v) => {});
      this.$router.push({
        path: "/fivenav/1",
        query: { action: "buyer" },
      });
      //this.$router.push({ name: 'fivenav/1', params: { needroute: true } }).catch((v) => {});
    },

    // 行业分布图

    // // 使用配置项和数据显示图表
    // myChart.setOption(option);

    // 价值区间分布图

    handleCheckAllApplication(val) {
      this.checkedApplicationAreas = val ? this.applicationAreas.slice() : [];
      this.isIndeterminateApplication = false;
    },
    transformData(data) {
      return data.map((item) => {
        const transformedItem = {
          value: item.id, // id作为value
          label: item.fieldName, // fieldName作为label
        };

        // 仅当存在子节点时才处理和添加children属性
        if (
          item.children &&
          Array.isArray(item.children) &&
          item.children.length > 0
        ) {
          transformedItem.children = this.transformData(item.children); // 递归处理子节点
        }

        return transformedItem;
      });
    },
    transformDatas(data) {
      return data.map((item) => {
        const transformedItem = {
          value: item.districtId, // id作为value
          label: item.districtName || item.fieldName, // districtName作为label
        };

        // 仅当存在子节点时才处理和添加children属性
        if (
          item.children &&
          Array.isArray(item.children) &&
          item.children.length > 0
        ) {
          transformedItem.children = this.transformDatas(item.children); // 递归处理子节点
        }

        return transformedItem;
      });
    },
    async handleCheckedApplicationAreas(value) {
      const token = localStorage.getItem("token");

      if (token == null) {
        this.dialogVisiblezhuce = true;
        //  this.$message({
        //   message: "登录可得三次免费试用机会",
        //   type: "info", // 可选类型：success、warning、info、error
        // });
      }
      this.needbigdata = value.join(",");

      this.items = [];
      this.totalPages = 0;
      this.selectedValue = [];
      this.selectedLabels = [];
      const selectedIds = value
        .map((selectedName) => {
          const selectedArea = this.applicationAreas.find(
            (area) => area.name === selectedName
          );
          return selectedArea ? selectedArea.id : null; // 返回 ID 或 null
        })
        .filter((id) => id !== null); // 过滤掉一些不存在的 id
      // this.cascaderHandleChange(this.coverData)
      // this.selectedLabels = this.getLabels(this.coverData);

      // const checkedCount = value.length;
      // this.checkAllApplication = checkedCount === this.applicationAreas.length;
      // this.isIndeterminateApplication =
      //   checkedCount > 0 && checkedCount < this.applicationAreas.length;

      try {
        // 构建请求 URL

        // const url = "https://www.hittik.com/zntop/top/getSectionShow";
        const params = {
          // name: "车辆运营数据,发车时刻表数据,车辆GPS数据,车辆颜色",
          sectionId: selectedIds,
          parentId: 0,
        };
        this.$api.getSectionShow(params).then((response) => {
          if (response) {
            this.options = this.transformData(response);
          }
        });
        // 发送 GET 请求
      } catch (error) {
        console.error("请求错误:", error);
      }
    },

    groupCheckAllApplication(val) {
      this.groupApplicationAreas = val ? this.dataGroup.slice() : [];
      this.groupIndeterminateApplication = false;
    },
    groupCheckedApplicationAreas(value) {
      const checkedCount = value.length;
      this.groupAllApplication = checkedCount === this.dataGroup.length;
      this.groupIndeterminateApplication =
        checkedCount > 0 && checkedCount < this.dataGroup.length;
    },
    combineArrays(arrays) {
      // 使用 map 遍历每个数组，然后用 join 将数组元素用逗号连接成字符串
      const combined = arrays.map((arr) => arr.join(","));
      // 使用 join 将所有字符串用逗号连接起来
      return combined.join(",");
    },
    // 生成产品建议
    async generateProductSuggestion() {
      const token = localStorage.getItem("token");

      if (token == null) {
        this.showDetailsFlags = false;
        this.showDetailsFlags = true;
        this.$store.commit("setDialogVisible", true);
      } else {
        this.showDetailsFlags = false;

        // 在请求开始时设置状态为加载中
        this.isLoading = true;
        var result = "";
        if (this.selectedLabels.length > 0) {
          console.log(this.selectedLabels);

          result = this.combineArrays([this.dataLists, this.selectedLabels]);
        } else {
          result = this.combineArrays([
            this.dataLists,
            this.groupApplicationAreas,
          ]);
        }

        // const result2 = this.combineArrays([
        //   this.dataLists,
        //   this.groupApplicationAreas,

        // ]);

        let resultnow = this.needbigdata + ";" + result;

        if (resultnow) {
          this.$api
            .getDevelop({
              name: resultnow,
              pageNum: this.currentPage,
              pageSize: 6,
            })
            .then((responses) => {
              if (responses) {
                //console.log(response.data);
                const responseData = responses.list; // 将响应数据保存到响应式数据属性中
                if (responseData.length > 0) {
                  this.totalPages = responses.list[0].titleNum;
                } else {
                  this.totalPages = 0;
                }
                this.items = responseData;
                this.items.forEach((item) => {
                  item.contentBuyer = "";
                  item.contentF = "";
                  item.suggestion = ""; // 移除 HTML 标签
                });
                this.isLoading = false;
              } else {
                this.isLoading = false;
              }
            });

          // 请求结束后设置状态为非加载中
        }
      }
    },

    processData(data) {
      const items = [];
      Object.keys(data).forEach((key) => {
        const group = data[key];
        group.forEach((item) => {
          const newItem = {
            productName: item.productName,
            productDescription: item.productDescription,
            fieldName: item.fieldName,
            activeNames: item.useData
              ? item.useData.map((useData) => useData.split(","))
              : [],
            children: item.useData
              ? [
                  {
                    productName: item.useData[0],
                    productDescription: item.useData[1],
                    fieldName: item.fieldName,
                    activeNames: [],
                    children: [],
                  },
                ]
              : [],
          };
          items.push(newItem);
        });
      });
      return items;
    },

    async getCardListData() {
      this.$api
        .getSection({
          parentId: 0,
        })
        .then((responses) => {
          if (responses) {
            //console.log(response.data);
            const newsList = responses;
            const hottt = responses.hotWord
              .map((item) => item.hotWordName) // 提取 hotWordName
              .filter((name) => name) // 过滤掉空字符串
              .join(" "); // 用空格拼接

            this.hotWord = hottt;

            const processItems = (list, property, targetArray) => {
              list.forEach((item) => {
                // 检查property是否存在且不为"全部"
                if (item[property] && item[property] !== "全部") {
                  targetArray.push({ id: item.id, name: item[property] }); // 存储对象，包括 ID 和名称
                }
              });
            };
            // 使用通用函数处理不同列表
            processItems(newsList.section, "fieldName", this.applicationAreas);
          }
        });

      // const res = await this.axios.get(
      //   "https://www.hittik.com/zntop/top/getSection?parentId=0"
      // );
      // this.bigdata = res.data.data;
    },

    // 分页
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    handleInput(value) {
      // 使用正则表达式检查输入是否只包含字母和数字
      const regex = /^[\u4e00-\u9fa5a-zA-z0-9]+$/;
      if (regex.test(value)) {
        // 如果输入符合要求，不做任何操作
        this.inputValue = value;
      } else {
        // 如果输入不符合要求，可以清空或提醒用户
        this.inputValue = this.inputValue.slice(0, -1); // 移除最后一个字符
        this.$message({
          message: "不能输入符号",
          type: "error", // 可选类型：success、warning、info、error
        });
      }
    },
  },
  async mounted() {
    await this.getCardListData();
    // this.handleCheckedApplicationAreas("金融服务");
    setTimeout(() => {
      this.initCharts();
    }, 2000);
    const userId = localStorage.getItem("userId");
    let timestamp = new Date().getTime();
    this.wsService = new WebSocketService(
      //  `ws://120.26.152.212:5000/ws/${userId}_${timestamp}`
     `wss://www.hittik.com/ws/${userId}_${timestamp}`
      //  `ws://192.168.80.19:5000/ws/${userId}_${timestamp}`
    );
    console.log(`wss://www.hittik.com/ws/${userId}_${timestamp}`);
    window.neddtime = userId + "_" + timestamp;
    this.wsService.connect();
    // marked.setOptions({
    //         renderer: new marked.Renderer(),
    //         pedantic: false,
    //         gfm: true,
    //         tables: true,
    //         sanitize: false,
    //         smartLists: true,
    //         smartypants: false
    //     })
    this.wsService.ws.onmessage = (event) => {
      // const jsonString = event.data;

      // 去掉开头和结尾的多余双引号
      //  const fixedJsonString = jsonString.slice(1, -1);

      //   // 替换中文引号为标准引号（如果需要）
      //  const cleanedJsonString = fixedJsonString.replace(/“/g, '"').replace(/”/g, '"');

      try {
        const data = event.data.replace(/None/g, "null");

        const obj = JSON.parse(data);
        for (var i = 0; i < this.items.length; i++) {
          let data = this.items[i];
          
          if (
            obj.type == "buyer_suggestion" &&
            obj.param.productId == data.productId &&
            obj.param.dataSource == data.dataSource
          ) {
            if (obj.status == 200) {
              this.items[i].contentBuyer += obj.content;
              this.$forceUpdate();
            } else {
              this.isLoadings = false;
              this.dialogVisiblehua = false;
              this.dialogVisibles = false;
              this.dialogVisiblesu = false;
            }
          }
          if (
            obj.type == "develop_suggestion" &&
            obj.param.productId == data.productId &&
            obj.param.dataSource == data.dataSource
          ) {
            if (obj.status == 200) {
              this.items[i].suggestion += obj.content;
              this.$forceUpdate();
            } else {
              this.isLoadings = false;
              this.dialogVisiblehua = false;
              this.dialogVisiblesu = false;
              this.dialogVisibles = false;
            }
          }
          if (
            obj.type == "financing_search" &&
            obj.param.productId == data.productId &&
            obj.param.dataSource == data.dataSource
          ) {
            // data.contentF += obj.content
            if (obj.status == 200) {
              this.items[i].contentF += obj.content;
              this.$forceUpdate();
            } else {
              this.isLoadings = false;
              this.dialogVisiblehua = false;
              this.dialogVisiblesu = false;
              this.dialogVisibles = false;
            }
          }
        }
        // this.dataList+=obj.content; // 将解析后的对象添加到数据列表中
      } catch (error) {
        console.error("解析失败:", error);
      }
    };
  },
};
</script>

<style scoped>
/* 自定义弹框样式 */
.custom-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
}

.dialog-header {
  text-align: center;
  padding: 30px 20px 20px;
  background: white;
  position: relative;
}

.dialog-title {
  font-size: 20px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 8px;
}

.dialog-body {
  padding: 30px 40px;
  background: #f5f7fa;
  text-align: center;
  line-height: 1.7;
  font-size: 16px;
  color: #606266;
}

.dialog-footer {
  padding: 25px;
  text-align: center;
  background: white;
}

.register-button {
  padding: 12px 50px;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.register-button:hover {
  background: #66b1ff;
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(64, 158, 255, 0.4);
}

.dialog-content {
  background: #f5f7fa;
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

.close-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 50%;
  color: #999;
  cursor: pointer;
  transition: all 0.3s;
}

.close-icon:hover {
  background: #f5f7fa;
  color: #333;
}

.container {
  display: flex;
  padding: 75px 261px;
  min-height: 100vh;
}

.sidebar {
  width: 200px;
  background-color: #f5f5f5;
  padding: 20px;
}

.nav {
  list-style: none;
  padding: 0;
}

.nav-item {
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
  cursor: pointer;
}

.nav-item.active {
  background-color: #007bff;
  color: #fff;
  border-color: #007bff;
}

::v-deep .el-collapse {
  width: 400px;
  max-height: 317px;

  border-radius: 4px;
}
::v-deep .el-collapse-item {
  padding: 2px;
}
.instate {
  background: #f6f6f6;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0%;
  overflow: auto;
  color: #989898;
  padding: 20px;
  height: 203px;
  margin-top: 10px;
}
.instate span {
  color: #333;
}

.main-content {
  flex: 1;
  padding-left: 20px;
}
.custom-checkbox-button {
  margin: 0 5px; /* 按钮之间的间隔 */
  border: none; /* 去除边框 */
  border-radius: 5px; /* 圆角效果 */
  margin-bottom: 5px;
}
::v-deep .el-checkbox-button__inner {
  /* background-color: rgba(8, 18, 43, 0.5); */
  background-color: none !important;
  border: none !important;
}
::v-deep.el-checkbox-button.is-checked .el-checkbox-button__inner {
  border-radius: 5px; /* 圆角效果 */
}

.filter-bar {
  margin-bottom: 20px;
}

.filter-title {
  font-weight: bold;
  margin-bottom: 10px;
}

.filter-tags {
  display: flex;
  flex-wrap: wrap;
}

.filter-tag {
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 5px 10px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 5px;
  cursor: pointer;
}
.filter-items {
  display: flex;
  flex-wrap: wrap;
}
.filter-item {
  width: 50%;
  display: flow-root;
}

.details-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  width: 100%;
  max-width: 1200px;
  padding: 0 70px 50px;
  text-align: left;
  overflow-y: auto;
  margin-top: -10px;
  height: 604px;
  font-size: 16px;
  line-height: 33px;
  position: relative;
  /* font-size: 20px;
line-height: 100%;
letter-spacing: 0%; */
}

.data-selection {
  margin-bottom: 20px;
}
.newsoan {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #333333;
  width: 5%;
}
.tuuiuy {
  margin-top: 15px;
  position: absolute;
}
.newsoans {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 0.83333vw;
  line-height: 1.25vw;
  letter-spacing: 0%;
  color: #333333;
  margin-top: -24px;
  margin-left: 35px;
  width: 80px;
  z-index: 100;
  height: 30px;
}
.newsoanss {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 0.83333vw;
  line-height: 1.25vw;
  letter-spacing: 0%;
  color: #333333;
  margin-top: -24px;
  margin-left: 230px;
  /* display: flex
; */
  position: relative;
  /* flex-direction: row; */
  /* width: 500px; */
  z-index: 100;
}

.data-title {
  font-weight: bold;
  margin-bottom: 10px;
}

.data-upload {
  margin-bottom: 10px;
}

.newgrpoup {
  display: contents;
}
.data-status {
  color: #666;
  display: flex;
  border: 1px solid #ddd;
  border-radius: 5px;
  background: #fbfbfb;
  padding: 10px 10px 12px 20px;
}
.needs {
  width: 100%;
  display: flex;
}
.needsss {
  width: 100%;
  display: flex;
}
.centers {
  width: 2px;
  height: 137px;
  margin-top: -15px;
  margin-left: 15px;
  background-color: rgb(181, 179, 179);
}

.filters {
  margin-left: -79px;
  margin-top: 12px;
}

::v-deep .el-collapse-item__wrap {
  border-bottom: none !important;
}
::v-deep .el-collapse-item__content {
  padding-bottom: 0 !important;
}
.generate-btn {
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 1086px;
}

.product-suggestion {
  margin-bottom: 20px;
}
::v-deep .el-radio-button__inner {
  /* background-color: rgba(8, 18, 43, 0.5); */
  background-color: none !important;
  border: none !important;
}
::v-deep.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  border-radius: 5px !important; /* 圆角效果 */
}

.hettmm {
  margin-top: 5px;
}
::v-deep.el-dialog__title {
  font-size: 26px;
  font-weight: 600;
  text-align: center;
  width: 100%;
}

.suggestion-header {
  display: flex;

  margin-bottom: 10px;
}
.newtag {
  width: 360px;
  display: flex;
  flex-wrap: wrap;
  /* align-items: flex-start; */
  margin: -1.82292vw 0 0 13.82292vw;
  align-items: normal;
  flex-direction: row;
  overflow-y: auto;
  height: 4.79167vw;
}
.newtags {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  width: 24.0625vw;
  margin: 0.625vw 0 0 11.82292vw;
  overflow-y: auto;
  height: 5.72917vw;
  border: 1px soild;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 5px;
}
.el-tag {
  margin-bottom: 5px; /* 标签之间的垂直间距 */
}

.details-content p {
  font-size: 16px;
  margin: 10px 0;
}
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.card-title {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0%;
  color: #333333;
}

.header h2 {
  margin: 0;
}
::v-deep .el-collapse-item__header {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0%;
  color: #333333;
  padding: 10 px;
  border-bottom: none !important;
  /* background: #F6F6F6; */
  border-radius: 5px !important;
  background-color: #f6f6f6 !important;
}

.close {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.charts-container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 创建两列，每列占据等宽空间 */
  grid-template-rows: repeat(2, 1fr); /* 创建两行，每行占据等宽空间 */
  gap: 10px; /* 设置网格项之间的间距 */
}

.chart {
  /* width: 48%; */
  height: 300px; /* 设置图表容器的高度 */
  border: none; /* 为图表容器添加边框 */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
}
.details-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.loader {
  border: 2px solid #f3f3f3; /* Light grey */
  border-top: 2px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 12px;
  height: 12px;
  animation: spin 1s linear infinite;
  display: inline-block; /* Ensure it displays inline with text */
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.suggestion-count {
  color: #809cba;

  margin-left: 5px;
}

.suggestion-item {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
}
.newimghh {
  width: 20px;
  height: 20px;
}
.newimg {
  width: 28px;
  height: 28px;
  padding: 2px;
}
.suggestion-title {
  font-weight: bold;
}

.suggestion-meta {
  color: #666;
}

.suggestion-body {
  margin: 10px 0;
}

.suggestion-actions {
  display: flex;
  justify-content: space-between;
}

.action-btn {
  padding: 5px 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.filter-container {
  padding: 20px;
  margin-bottom: 10px;
  border: 1px solid #d2dadf;
  border-radius: 5px;
  padding-bottom: 5px;
}
.filter-containers {
  padding: 20px;

  border: 1px solid #d2dadf;
  border-radius: 5px;
  padding-bottom: 5px;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.pagination button {
  margin: 0 10px;
  padding: 5px 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.qr-code {
  position: fixed;
  right: 20px;
  top: 20px;
  width: 150px;
  text-align: center;
}

.qr-code img {
  width: 100%;
  height: auto;
}

/* .card-container {
  padding: 20px;
} */

.custom-card {
  position: relative;
  padding: 10px;
  max-height: 450px;
  height: 325px;
  overflow-y: auto;
  margin-bottom: 10px;
}

.card-content {
  margin-bottom: 20px;
}
.card-content P {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #989898;
}
.card-contents {
  display: flex;
  flex-direction: row;
}

.card-actions {
  position: absolute;
  right: 112px;
  bottom: 6px;
}

.el-button {
  border-radius: 4px; /* 圆角边框 */
  font-size: 14px; /* 字体大小 */
}

.el-button--mini {
  padding: 5px 10px; /* 按钮内边距 */
  border: 1px solid;
}
.card-actions {
  position: absolute;
  bottom: 5px;
  right: 100px;
}

::v-deep .el-popper {
  position: fixed !important;
  top: 100px !important; /* 自定义顶部位置 */
  left: 50px !important; /* 自定义左侧位置 */
}
::v-deep .el-cascader__dropdown {
  top: 150px !important; /* 向下移动 50px */
}

::v-deep .el-cascader-panel {
  top: 150px !important; /* 向下移动 50px */
}
::v-deep .el-cascader-panel {
  margin-top: 264px !important;
}
::v-deep .el-dialog__title {
  line-height: 1.25vw;
  font-size: 30px;
  color: #303133;
  padding-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: 100%;
}
.preview-content {
  width: 100%;
  height: calc(100% - 40px);
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow-y: auto;
  text-align: left;
}
/* ::v-deep(.dialog-style.el-dialog__title){
font-size: 10px !important;
} */
.dialog-style ::v-deep(.el-dialog__title) {
  line-height: 1.25vw;
  font-size: 16px;
  color: #303133;
  padding-bottom: 10px;

  display: block;
}
/* .card-actions .el-button {
  margin-left: 10px;
} */
</style>
